import { render, staticRenderFns } from "./jobSearch.vue?vue&type=template&id=66205596&scoped=true"
import script from "./jobSearch.vue?vue&type=script&lang=js"
export * from "./jobSearch.vue?vue&type=script&lang=js"
import style0 from "./jobSearch.vue?vue&type=style&index=0&id=66205596&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66205596",
  null
  
)

export default component.exports